import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { SvgIcon } from "@mui/material";

const useStyles = makeStyles(theme => ({
  icon: {
    "&.small": {
      maxHeight: "1rem",
      width: "unset"
    }
  }
}));

export default function CalendarIcon(props) {
  const classes = useStyles();

  return (
    <SvgIcon
      classes={{ root: classes.icon }}
      className={props.size}
      onClick={props.click}
      color={props.color}
    >
      <g id="surface1">
        <path d="M 3.585938 0.308594 C 3.574219 0.320312 3.566406 0.78125 3.566406 1.335938 L 3.566406 2.34375 L 2.847656 2.355469 C 2.195312 2.363281 2.113281 2.375 1.941406 2.433594 C 1.273438 2.664062 0.839844 3.113281 0.605469 3.8125 L 0.535156 4.015625 L 0.527344 11.429688 C 0.523438 17.800781 0.527344 18.871094 0.5625 19.039062 C 0.714844 19.765625 1.207031 20.320312 1.925781 20.570312 L 2.160156 20.652344 L 5.285156 20.660156 L 8.40625 20.667969 L 8.40625 18.636719 L 2.726562 18.636719 L 2.726562 7.421875 L 9.847656 7.425781 L 16.972656 7.433594 L 16.980469 8.453125 L 16.984375 9.476562 L 18.839844 9.476562 L 18.839844 6.808594 C 18.839844 3.859375 18.847656 3.9375 18.652344 3.523438 C 18.414062 3.007812 17.988281 2.628906 17.421875 2.433594 C 17.25 2.375 17.164062 2.363281 16.515625 2.355469 L 15.796875 2.34375 L 15.792969 1.324219 L 15.78125 0.304688 L 13.753906 0.304688 L 13.746094 1.324219 L 13.738281 2.347656 L 5.625 2.347656 L 5.617188 1.324219 L 5.609375 0.304688 L 4.605469 0.296875 C 4.054688 0.292969 3.597656 0.296875 3.585938 0.308594 Z M 3.585938 0.308594 " />
        <path d="M 16.289062 10.523438 C 14.039062 10.78125 12.105469 12.050781 11.117188 13.921875 C 10.445312 15.183594 10.277344 16.613281 10.628906 18.015625 C 11.050781 19.707031 12.332031 21.21875 14.015625 22.015625 C 14.625 22.308594 15.191406 22.484375 15.898438 22.613281 C 16.386719 22.699219 17.371094 22.722656 17.910156 22.65625 C 20.730469 22.308594 22.980469 20.382812 23.546875 17.824219 C 23.972656 15.898438 23.375 13.910156 21.9375 12.464844 C 20.882812 11.40625 19.441406 10.714844 17.894531 10.535156 C 17.496094 10.488281 16.65625 10.484375 16.289062 10.523438 Z M 18.175781 14.058594 L 18.175781 15.59375 L 21.476562 15.59375 L 21.476562 17.625 L 18.175781 17.625 L 18.175781 20.667969 L 15.972656 20.667969 L 15.972656 17.625 L 12.667969 17.625 L 12.667969 15.59375 L 14.3125 15.589844 L 15.957031 15.578125 L 15.972656 12.523438 L 18.175781 12.523438 Z M 18.175781 14.058594 " />
      </g>
    </SvgIcon>
  );
}
